import { useInfluencerId } from '@client/new/contexts/InfluencerIdContext';
import { useInfluencer } from '@client/new/hooks/use-influencer';
import * as enums from '@playbook-technologies/common-enums';

interface PaymentMethod {
  name: string;
  value: number;
}

export const usePaymentMethod = (paymentMethod?: number): PaymentMethod => {
  const creatorId = useInfluencerId();
  const { influencer } = useInfluencer({
    creatorId,
  });

  const stripePaymentMethod: PaymentMethod = {
    ...enums.Influencer.PaymentMethod.StripeConnect,
    name: 'Stripe',
  };

  switch (paymentMethod ?? influencer?.paymentMethod) {
    case enums.Influencer.PaymentMethod.StripeConnect.value:
      return stripePaymentMethod;
    case enums.Influencer.PaymentMethod.PayPal.value:
      return { ...enums.Influencer.PaymentMethod.PayPal, name: 'PayPal' };
    case enums.Influencer.PaymentMethod.WireTransfer.value:
      return { ...enums.Influencer.PaymentMethod.WireTransfer, name: 'Wire' };
    default:
      return stripePaymentMethod;
  }
};
